export default {"src":"/_next/static/media/play.35e78a60.svg","height":18,"width":16};